export const colors = {
  "gradient": {
    headerlineardark: {
      description: "",
      type: "custom-gradient",
      value: {
        gradientType: "linear",
        rotation: 90,
        stops: [
          { position: 0, color: "#e5e7ebcc" },
          { position: 0.5, color: "#e5e7ebff" },
          { position: 1, color: "#e5e7ebcc" },
        ],
      },
    },
    headerlinearlight: {
      description: "",
      type: "custom-gradient",
      value: {
        gradientType: "linear",
        rotation: 90,
        stops: [
          { position: 0, color: "#0e121bbf" },
          { position: 0.5, color: "#0e121bff" },
          { position: 1, color: "#0e121bbf" },
        ],
      },
    },
    flarebackground: {
      description: "",
      type: "custom-gradient",
      value: {
        gradientType: "linear",
        rotation: 271.59337821048814,
        stops: [
          { position: 0, color: "#ffffff0a" },
          { position: 0.19, color: "#1818185c" },
          { position: 0.85, color: "#00000063" },
          { position: 1, color: "#ffffff45" },
        ],
      },
    },
    linearheader: {
      description: "",
      type: "custom-gradient",
      value: {
        gradientType: "linear",
        rotation: 179.99999574237816,
        stops: [
          { position: 0, color: "#f5f7fa00" },
          { position: 1, color: "#f5f7faff" },
        ],
      },
    },
    radialphoto: {
      "0": {
        type: "custom-gradient",
        value: {
          gradientType: "radial",
          rotation: 81.09953036381773,
          stops: [
            { position: 0, color: "#6c91ff29" },
            { position: 1, color: "#ffffff00" },
          ],
        },
      },
      "1": {
        type: "custom-gradient",
        value: {
          gradientType: "radial",
          rotation: 82.81861562997426,
          stops: [
            { position: 0, color: "#6c91ff1a" },
            { position: 1, color: "#ffffff00" },
          ],
        },
      },
      "description": "",
    },
    timelinegradient: {
      description: "",
      type: "custom-gradient",
      value: {
        gradientType: "linear",
        rotation: 180,
        stops: [
          { position: 0.1, color: "#2b303bff" },
          { position: 0.15, color: "#96c5f0ff" },
          { position: 0.5, color: "#05df54ff" },
          { position: 0.85, color: "#96c5f0ff" },
          { position: 0.9, color: "#2b303bff" },
        ],
      },
    },
    main: {
      backgroundcolor: {
        description: "",
        type: "custom-gradient",
        value: {
          gradientType: "linear",
          rotation: 180.02583882722175,
          stops: [
            { position: 0, color: "#69f59cff" },
            { position: 0.52, color: "#d6fd4bff" },
            { position: 1, color: "#69f59cff" },
          ],
        },
      },
      gradient: {
        description: "",
        type: "custom-gradient",
        value: {
          gradientType: "linear",
          rotation: 332.4699884849931,
          stops: [
            { position: 0, color: "#05df54ff" },
            { position: 0.76, color: "#96c5f0ff" },
          ],
        },
      },
      backgroundfooterlight: {
        description: "",
        type: "custom-gradient",
        value: {
          gradientType: "linear",
          rotation: 159.81075216810385,
          stops: [
            { position: 0, color: "#e1faeeff" },
            { position: 0.67, color: "#05df54ab" },
            { position: 1, color: "#96c5f0d4" },
          ],
        },
      },
      backgroundfooterdark: {
        description: "",
        type: "custom-gradient",
        value: {
          gradientType: "linear",
          rotation: 159.81075216810385,
          stops: [
            { position: 0, color: "#181b25ff" },
            { position: 0.67, color: "#05df54ab" },
            { position: 1, color: "#96c5f0d4" },
          ],
        },
      },
    },
    embedded: {
      linear: {
        description: "",
        type: "custom-gradient",
        value: {
          gradientType: "linear",
          rotation: 90,
          stops: [
            { position: 0, color: "#335cffcc" },
            { position: 0.5, color: "#335cffff" },
            { position: 1, color: "#335cffcc" },
          ],
        },
      },
      backgroundcolor: {
        description: "",
        type: "custom-gradient",
        value: {
          gradientType: "linear",
          rotation: 180.02583882722175,
          stops: [
            { position: 0, color: "#545582ff" },
            { position: 0.52, color: "#0033a3ff" },
            { position: 1, color: "#545582ff" },
          ],
        },
      },
    },
    automation: {
      linear: {
        description: "",
        type: "custom-gradient",
        value: {
          gradientType: "linear",
          rotation: 90,
          stops: [
            { position: 0, color: "#7d52f4cc" },
            { position: 0.5, color: "#7d52f4ff" },
            { position: 1, color: "#7d52f4cc" },
          ],
        },
      },
      backgroundcolor: {
        description: "",
        type: "custom-gradient",
        value: {
          gradientType: "linear",
          rotation: 180.02583882722175,
          stops: [
            { position: 0, color: "#545582ff" },
            { position: 0.52, color: "#7d52f4ff" },
            { position: 1, color: "#545582ff" },
          ],
        },
      },
    },
  },
  "color": {
    main: {
      flatleft: {
        description: "",
        type: "color",
        value: "#05df54ff",
        blendMode: "normal",
      },
      flatright: {
        description: "",
        type: "color",
        value: "#96c5f0ff",
        blendMode: "normal",
      },
    },
    embedded: {
      flat: {
        description: "",
        type: "color",
        value: "#5a7bfeff",
        blendMode: "normal",
      },
    },
    automation: {
      flat: {
        description: "",
        type: "color",
        value: "#9573f5ff",
        blendMode: "normal",
      },
    },
  },
  "01-foundations": {
    neutral: {
      "0": { type: "color", value: "#ffffffff", blendMode: "normal" },
      "50": { type: "color", value: "#f5f7faff", blendMode: "normal" },
      "100": { type: "color", value: "#f2f5f8ff", blendMode: "normal" },
      "200": { type: "color", value: "#e1e4eaff", blendMode: "normal" },
      "300": { type: "color", value: "#cacfd8ff", blendMode: "normal" },
      "400": { type: "color", value: "#99a0aeff", blendMode: "normal" },
      "500": { type: "color", value: "#717784ff", blendMode: "normal" },
      "600": { type: "color", value: "#525866ff", blendMode: "normal" },
      "700": { type: "color", value: "#2b303bff", blendMode: "normal" },
      "800": { type: "color", value: "#222530ff", blendMode: "normal" },
      "900": { type: "color", value: "#181b25ff", blendMode: "normal" },
      "950": { type: "color", value: "#0e121bff", blendMode: "normal" },
    },
    teal: {
      "50": { type: "color", value: "#e4fbf8ff", blendMode: "normal" },
      "100": { type: "color", value: "#d0fbf5ff", blendMode: "normal" },
      "200": { type: "color", value: "#c2f5eeff", blendMode: "normal" },
      "300": { type: "color", value: "#84ebddff", blendMode: "normal" },
      "400": { type: "color", value: "#3fdec9ff", blendMode: "normal" },
      "500": { type: "color", value: "#22d3bbff", blendMode: "normal" },
      "600": { type: "color", value: "#1daf9cff", blendMode: "normal" },
      "700": { type: "color", value: "#178c7dff", blendMode: "normal" },
      "800": { type: "color", value: "#1a7569ff", blendMode: "normal" },
      "900": { type: "color", value: "#16645aff", blendMode: "normal" },
      "950": { type: "color", value: "#0b463eff", blendMode: "normal" },
    },
    blue: {
      "50": { type: "color", value: "#ebf1ffff", blendMode: "normal" },
      "100": { type: "color", value: "#d5e2ffff", blendMode: "normal" },
      "200": { type: "color", value: "#c0d5ffff", blendMode: "normal" },
      "300": { type: "color", value: "#97baffff", blendMode: "normal" },
      "400": { type: "color", value: "#6895ffff", blendMode: "normal" },
      "500": { type: "color", value: "#335cffff", blendMode: "normal" },
      "600": { type: "color", value: "#3559e9ff", blendMode: "normal" },
      "700": { type: "color", value: "#2547d0ff", blendMode: "normal" },
      "800": { type: "color", value: "#1f3badff", blendMode: "normal" },
      "900": { type: "color", value: "#182f8bff", blendMode: "normal" },
      "950": { type: "color", value: "#122368ff", blendMode: "normal" },
    },
    purple: {
      "50": { type: "color", value: "#efebffff", blendMode: "normal" },
      "100": { type: "color", value: "#dcd5ffff", blendMode: "normal" },
      "200": { type: "color", value: "#cac0ffff", blendMode: "normal" },
      "300": { type: "color", value: "#a897ffff", blendMode: "normal" },
      "400": { type: "color", value: "#8c71f6ff", blendMode: "normal" },
      "500": { type: "color", value: "#7d52f4ff", blendMode: "normal" },
      "600": { type: "color", value: "#693ee0ff", blendMode: "normal" },
      "700": { type: "color", value: "#5b2cc9ff", blendMode: "normal" },
      "800": { type: "color", value: "#4c25a7ff", blendMode: "normal" },
      "900": { type: "color", value: "#3d1d86ff", blendMode: "normal" },
      "950": { type: "color", value: "#351a75ff", blendMode: "normal" },
    },
    alpha: {
      green: {
        "alpha-10": { type: "color", value: "#1fc16b1a", blendMode: "normal" },
        "alpha-16": { type: "color", value: "#1fc16b29", blendMode: "normal" },
        "alpha-24": { type: "color", value: "#1fc16b3d", blendMode: "normal" },
      },
      blue: {
        "alpha-10": { type: "color", value: "#476cff1a", blendMode: "normal" },
        "alpha-16": { type: "color", value: "#476cff29", blendMode: "normal" },
        "alpha-24": { type: "color", value: "#476cff3d", blendMode: "normal" },
      },
      neutral: {
        "alpha-10": { type: "color", value: "#99a0ae1a", blendMode: "normal" },
        "alpha-16": { type: "color", value: "#99a0ae29", blendMode: "normal" },
        "alpha-24": { type: "color", value: "#99a0ae3d", blendMode: "normal" },
      },
      teal: {
        "alpha-10": { type: "color", value: "#22d3bb1a", blendMode: "normal" },
        "alpha-16": { type: "color", value: "#22d3bb29", blendMode: "normal" },
        "alpha-24": { type: "color", value: "#22d3bb3d", blendMode: "normal" },
      },
      purple: {
        "alpha-10": { type: "color", value: "#784def1a", blendMode: "normal" },
        "alpha-16": { type: "color", value: "#784def29", blendMode: "normal" },
        "alpha-24": { type: "color", value: "#784def3d", blendMode: "normal" },
      },
      white: {
        "alpha-24": { type: "color", value: "#ffffff3d", blendMode: "normal" },
        "alpha-16": { type: "color", value: "#ffffff29", blendMode: "normal" },
        "alpha-10": { type: "color", value: "#ffffff1a", blendMode: "normal" },
      },
      black: {
        "alpha-24": { type: "color", value: "#0e121b3d", blendMode: "normal" },
        "alpha-16": { type: "color", value: "#0e121b29", blendMode: "normal" },
        "alpha-10": { type: "color", value: "#0e121b1a", blendMode: "normal" },
      },
      red: {
        "alpha-24": { type: "color", value: "#fb37483d", blendMode: "normal" },
        "alpha-16": { type: "color", value: "#fb374829", blendMode: "normal" },
        "alpha-10": { type: "color", value: "#fb37481a", blendMode: "normal" },
      },
    },
    red: {
      "50": { type: "color", value: "#ffebecff", blendMode: "normal" },
      "100": { type: "color", value: "#ffd5d8ff", blendMode: "normal" },
      "200": { type: "color", value: "#ffc0c5ff", blendMode: "normal" },
      "300": { type: "color", value: "#ff97a0ff", blendMode: "normal" },
      "400": { type: "color", value: "#ff6875ff", blendMode: "normal" },
      "500": { type: "color", value: "#fb3748ff", blendMode: "normal" },
      "600": { type: "color", value: "#e93544ff", blendMode: "normal" },
      "700": { type: "color", value: "#d02533ff", blendMode: "normal" },
      "800": { type: "color", value: "#ad1f2bff", blendMode: "normal" },
      "900": { type: "color", value: "#8b1822ff", blendMode: "normal" },
      "950": { type: "color", value: "#681219ff", blendMode: "normal" },
    },
  },
  "02-tokens": {
    light: {
      static: {
        "static-white": {
          type: "color",
          value: "{01-foundations.light.neutral.0}",
        },
        "static-black": {
          type: "color",
          value: "{01-foundations.light.neutral.950}",
        },
      },
      bg: {
        "white-0": { type: "color", value: "{01-foundations.light.neutral.0}" },
        "weak-50": {
          type: "color",
          value: "{01-foundations.light.neutral.50}",
        },
        "strong-950": {
          type: "color",
          value: "{01-foundations.light.neutral.950}",
        },
        "surface-800": {
          type: "color",
          value: "{01-foundations.light.neutral.800}",
        },
        "soft-200": {
          type: "color",
          value: "{01-foundations.light.neutral.0}",
        },
        "sub-300": {
          type: "color",
          value: "{01-foundations.light.neutral.300}",
        },
      },
      text: {
        "strong-950": {
          type: "color",
          value: "{01-foundations.light.neutral.950}",
        },
        "sub-600": {
          type: "color",
          value: "{01-foundations.light.neutral.600}",
        },
        "disabled-300": {
          type: "color",
          value: "{01-foundations.light.neutral.300}",
        },
        "white-0": { type: "color", value: "{01-foundations.light.neutral.0}" },
        "soft-400": {
          type: "color",
          value: "{01-foundations.light.neutral.400}",
        },
      },
      stroke: {
        "soft-200": {
          type: "color",
          value: "{01-foundations.light.neutral.100}",
        },
        "strong-950": {
          type: "color",
          value: "{01-foundations.light.neutral.950}",
        },
        "white-0": { type: "color", value: "{01-foundations.light.neutral.0}" },
        "sub-300": {
          type: "color",
          value: "{01-foundations.light.neutral.300}",
        },
      },
      icon: {
        "sub-600": {
          type: "color",
          value: "{01-foundations.light.neutral.600}",
        },
        "strong-950": {
          type: "color",
          value: "{01-foundations.light.neutral.950}",
        },
        "soft-400": {
          type: "color",
          value: "{01-foundations.light.neutral.400}",
        },
        "disabled-300": {
          type: "color",
          value: "{01-foundations.light.neutral.300}",
        },
        "white-0": { type: "color", value: "{01-foundations.light.neutral.0}" },
      },
      casestudy: {
        embedded: {
          dark: { type: "color", value: "{01-foundations.light.blue.600}" },
          base: { type: "color", value: "{01-foundations.light.blue.500}" },
          light: { type: "color", value: "{01-foundations.light.blue.200}" },
          lighter: { type: "color", value: "{01-foundations.light.blue.50}" },
        },
        automation: {
          dark: { type: "color", value: "{01-foundations.light.purple.600}" },
          base: { type: "color", value: "{01-foundations.light.purple.500}" },
          light: { type: "color", value: "{01-foundations.light.purple.200}" },
          lighter: { type: "color", value: "{01-foundations.light.purple.50}" },
        },
        agile: {
          dark: { type: "color", value: "{01-foundations.light.teal.600}" },
          base: { type: "color", value: "{01-foundations.light.teal.500}" },
          light: { type: "color", value: "{01-foundations.light.teal.200}" },
          lighter: { type: "color", value: "{01-foundations.light.teal.50}" },
        },
      },
      overlay: {
        overlay: { type: "color", value: "#020d173d", blendMode: "normal" },
      },
      error: {
        dark: { type: "color", value: "{01-foundations.light.red.950}" },
        base: { type: "color", value: "{01-foundations.light.red.500}" },
        light: { type: "color", value: "{01-foundations.light.red.200}" },
        lighter: { type: "color", value: "{01-foundations.light.red.50}" },
      },
    },
    dark: {
      static: {
        "static-white": {
          type: "color",
          value: "{01-foundations.dark.neutral.50}",
        },
        "static-black": {
          type: "color",
          value: "{01-foundations.dark.neutral.950}",
        },
      },
      bg: {
        "white-0": {
          type: "color",
          value: "{01-foundations.dark.neutral.950}",
        },
        "weak-50": {
          type: "color",
          value: "{01-foundations.dark.neutral.900}",
        },
        "strong-950": {
          type: "color",
          value: "{01-foundations.dark.neutral.0}",
        },
        "surface-800": {
          type: "color",
          value: "{01-foundations.dark.neutral.200}",
        },
        "soft-200": {
          type: "color",
          value: "{01-foundations.dark.neutral.800}",
        },
        "sub-300": {
          type: "color",
          value: "{01-foundations.dark.neutral.600}",
        },
      },
      text: {
        "strong-950": {
          type: "color",
          value: "{01-foundations.dark.neutral.0}",
        },
        "sub-600": {
          type: "color",
          value: "{01-foundations.dark.neutral.400}",
        },
        "disabled-300": {
          type: "color",
          value: "{01-foundations.dark.neutral.600}",
        },
        "white-0": {
          type: "color",
          value: "{01-foundations.dark.neutral.950}",
        },
        "soft-400": {
          type: "color",
          value: "{01-foundations.dark.neutral.500}",
        },
      },
      stroke: {
        "soft-200": {
          type: "color",
          value: "{01-foundations.dark.neutral.700}",
        },
        "strong-950": {
          type: "color",
          value: "{01-foundations.dark.neutral.0}",
        },
        "white-0": {
          type: "color",
          value: "{01-foundations.dark.neutral.950}",
        },
        "sub-300": {
          type: "color",
          value: "{01-foundations.dark.neutral.600}",
        },
      },
      icon: {
        "sub-600": {
          type: "color",
          value: "{01-foundations.dark.neutral.400}",
        },
        "strong-950": {
          type: "color",
          value: "{01-foundations.dark.neutral.0}",
        },
        "soft-400": {
          type: "color",
          value: "{01-foundations.dark.neutral.500}",
        },
        "disabled-300": {
          type: "color",
          value: "{01-foundations.dark.neutral.600}",
        },
        "white-0": {
          type: "color",
          value: "{01-foundations.dark.neutral.950}",
        },
      },
      casestudy: {
        embedded: {
          dark: { type: "color", value: "{01-foundations.dark.blue.400}" },
          base: { type: "color", value: "{01-foundations.dark.blue.500}" },
          light: {
            type: "color",
            value: "{01-foundations.dark.alpha.blue.alpha-24}",
          },
          lighter: {
            type: "color",
            value: "{01-foundations.dark.alpha.blue.alpha-16}",
          },
        },
        automation: {
          dark: { type: "color", value: "{01-foundations.dark.purple.400}" },
          base: { type: "color", value: "{01-foundations.dark.purple.500}" },
          light: {
            type: "color",
            value: "{01-foundations.dark.alpha.purple.alpha-24}",
          },
          lighter: {
            type: "color",
            value: "{01-foundations.dark.alpha.purple.alpha-16}",
          },
        },
        agile: {
          dark: { type: "color", value: "{01-foundations.dark.teal.400}" },
          base: { type: "color", value: "{01-foundations.dark.teal.600}" },
          light: {
            type: "color",
            value: "{01-foundations.dark.alpha.teal.alpha-24}",
          },
          lighter: {
            type: "color",
            value: "{01-foundations.dark.alpha.teal.alpha-16}",
          },
        },
      },
      overlay: {
        overlay: { type: "color", value: "#52586652", blendMode: "normal" },
      },
      error: {
        dark: { type: "color", value: "{01-foundations.dark.red.400}" },
        base: { type: "color", value: "{01-foundations.dark.red.600}" },
        light: {
          type: "color",
          value: "{01-foundations.dark.alpha.red.alpha-24}",
        },
        lighter: {
          type: "color",
          value: "{01-foundations.dark.alpha.red.alpha-16}",
        },
      },
    },
  },
  "03-theme": {
    "primary-dark": {
      type: "color",
      value: "{01-foundations.💙 blue.blue.800}",
    },
    "primary-darker": {
      type: "color",
      value: "{01-foundations.💙 blue.blue.700}",
    },
    "primary-base": {
      type: "color",
      value: "{01-foundations.💙 blue.blue.500}",
    },
    "primary-alpha-24": {
      type: "color",
      value: "{01-foundations.💙 blue.alpha.blue.alpha-24}",
    },
    "primary-alpha-16": {
      type: "color",
      value: "{01-foundations.💙 blue.alpha.blue.alpha-16}",
    },
    "primary-alpha-10": {
      type: "color",
      value: "{01-foundations.💙 blue.alpha.blue.alpha-10}",
    },
  },
};
